import { DeepPartial, DynamicConfig } from '@empathybroker/ebx-gluon';

export const DYNAMIC_CONFIG: DeepPartial<DynamicConfig> = {
  store: 'es',
  endpoints: {
    searchById: 'https://api{env}.empathybroker.com/search/v1/query/cdl/isbnsearch',
    search: 'https://api{env}.empathybroker.com/search/v1/query/cdl/searchv2'
  }
};
